import { render } from "./ListeConsultation.vue?vue&type=template&id=bb22764a&scoped=true"
import script from "./ListeConsultation.vue?vue&type=script&lang=js"
export * from "./ListeConsultation.vue?vue&type=script&lang=js"

import "./ListeConsultation.vue?vue&type=style&index=0&id=bb22764a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb22764a"]])

export default __exports__